import {
  AnalysisPage,
  BettingPage,
  BettingPurchasePage,
  CalculatePage,
  CustomerPage,
  HistoryPage,
  LoginPage,
  OddsTransferPage,
  ReportPage,
} from "../pages";
import { routeName } from "../constants/routePaths";

const routes = [
  { path: routeName.loginRoute, component: LoginPage, exact: true },
  { path: routeName.oddTransferRoute, component: OddsTransferPage, exact: true },
  { path: routeName.bettingRoute, component: BettingPage, exact: true },
  { path: routeName.reportRoute, component: ReportPage, exact: true },
  { path: routeName.outstandingRoute, component: HistoryPage, exact: true },
  { path: routeName.calculateRoute, component: CalculatePage, exact: true },
  { path: routeName.customerRoute, component: CustomerPage, exact: true },
  { path: routeName.analysisRoute, component: AnalysisPage, exact: true },
  { path: routeName.purchaseRoute, component: BettingPurchasePage, exact: true },
];

export { routeName };
export default routes;
